import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const CustomsDuty = () => {
  return (
    <>
      <TopBanner content={"Customs Duty"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>Tax on Goods Entering or Leaving the Country</h2>
          <p>
            Customs Duty is a tax imposed on goods when they are imported into
            or exported out of India. It helps regulate international trade,
            protect local industries, and generate revenue for the government.
          </p>

          <p>
            If you buy goods from abroad or carry items beyond a certain limit
            while travelling, customs duty may apply.
          </p>

          <h3>Key Points:</h3>
          <ul>
            <li>Paid on imported or exported goods</li>
            <li>Rates vary based on product type and country of origin</li>
            <li>
              Personal items brought from overseas can be duty-free up to a
              certain limit
            </li>
            <li>Applicable to businesses and individuals alike</li>
          </ul>

          <p>
            Whether it’s a gift or a gadget, know your customs duty to avoid
            surprises at the airport or border.
          </p>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default CustomsDuty;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
